import { use } from "react";
import { AppAssistenteIAContext } from "../contexts/AppAssistenteIAContext";

export function useAppAssistenteIA() {
	const context = use(AppAssistenteIAContext);

	if (context === undefined) throw new Error("useAppAssistenteIA deve ser usado dentro de AppAssistenteIAProvider");

	return context;
}
